import { defineComponent as _defineComponent } from 'vue'
import type { SportType } from '@/@types/graphql-types';
import { ObjectType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'SportHeader',
  props: {
    path: null,
    sportType: null,
    isIcon: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	path: string;
	sportType: SportType;
	isIcon?: boolean;
};



function handleClick(location: 'sport' | 'text') {
	const sportContext = new SnowplowSportContext(props.sportType, ObjectType.Sport);
	switch (location) {
		// SPORT ICON
		case 'sport':
			TrackingHelper.trackEvent(
				'userinteraction',
				{
					action: 'sport_clicked',
					property: 'module',
				},
				[sportContext]
			);
			break;

		// MORE DETAILS TEXT
		case 'text':
			TrackingHelper.trackEvent('userinteraction', { action: 'all_matches_clicked' }, [sportContext]);
			break;
	}
}

return { __sfc: true,props, handleClick, faChevronRight }
}

})